export default "__VITE_ASSET__Bz9AeR7i__"